<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1">
        <input
          class="input hidden"
          ref="input"
          type="file"
          @change="recordAnswer"
          multiple
        />
        <button class="button is-primary" @click="$refs.input.click()">
          Add Files
        </button>
        <hr />
      </div>

      <div class="columns mt2">
        <div v-if="errors.length > 0" class="column has-text-left">
          <h3>Errors</h3>
          <div v-for="(error, index) in errors" v-bind:key="index">
            <p>{{ error.message }}</p>
          </div>
        </div>
        <div v-if="choice.length > 0" class="column has-text-left">
          <h3>Files</h3>
          <div
            v-for="(file, index) in choice"
            v-bind:key="index"
            class="file-container"
          >
            <img
              v-if="$isImage(file)"
              :src="file.data"
              alt="image"
              width="150"
            />
            <i v-if="!$isImage(file)" class="fa fa-file"></i>
            <p>{{ file.name }}</p>
            <button class="button remove" @click="removeImage(index)">
              Remove
            </button>
          </div>
        </div>
      </div>
      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import baseQuestion from "./baseQuestion";

export default {
  name: "file",

  mixins: [baseQuestion],

  data() {
    return {
      errors: [],
      // the content types are also duplicated in the virtriage-api project in app/models/interview_image.rb
      contentTypes: [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/gif",
        "application/pdf",
        "file/txt",
        "text/plain",
        "application/doc",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      ],
      choice: []
    };
  },

  methods: {
    encodeImages(files, file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        // eslint-disable-next-line
        reader.onloadend = function () {
          files.push({
            name: file.name,
            data: this.result,
            type: file.type
          });
          return resolve();
        };

        // convert to base64
        reader.readAsDataURL(file);
      });
    },
    recordAnswer(e) {
      let promise = Promise.resolve();
      const files = this.choice || [];
      this.errors = [];
      _.forEach(e.target.files, file => {
        if (_.includes(this.contentTypes, file.type)) {
          promise = promise.then(() => this.encodeImages(files, file));
        } else {
          this.errors.push({
            message: file.name + " is not an allowed type of file.",
            file: file
          });
        }
      });

      promise = promise.then(() => {
        this.choice = files;
        this.$store.dispatch("interview/setNext", true);
      });
    },
    removeImage(index) {
      this.choice.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.remove {
  margin-left: 0;
  height: auto !important;
  padding: 8px 12px;
  line-height: 1.5rem !important;
}
.file-container {
  margin-bottom: 20px;
}
.fa-file {
  font-size: 110px;
  margin-bottom: 10px;
}
</style>
